import { Component, forwardRef, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormControl, NgControl, ControlValueAccessor } from '@angular/forms';

@Component({
    selector: 'abw-multipack-custom-number-input',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AbwMultipackCustomNumberInputComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => AbwMultipackCustomNumberInputComponent),
            multi: true
        }
    ],
    templateUrl: './custom-number-input.component.html',
})
export class AbwMultipackCustomNumberInputComponent implements OnInit, OnChanges, ControlValueAccessor {
    label = 'Montant'
    value: any;
    numericValue: number;

    constructor() { }

    ngOnInit(): void {

    }

    ngOnChanges(changes: SimpleChanges): void {

    }

    propagateChange = (_: any) => { };
    registerOnChange(fn) { this.propagateChange = fn; }
    registerOnTouched() { }
    writeValue(value: any) {
        const numericValue: number = !!value ? parseFloat(value.toString().replace(/\s/g, "").replace(",", ".")) : null;
        this.value = numericValue; 
        this.numericValue = numericValue;
    }

    validate({ value }: FormControl) {
        const isValid = false && !value;
        return isValid && {
            invalid: true
        };
    }

    onKeydown(_event) {
        const allowKey = ["-", "Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"];
        const allowNumber = /[0-9]/.test(_event.key);
        const separator = _event.key === "." || _event.key === ",";
        if (!allowNumber && !allowKey.includes(_event.key) && !separator) {
            _event.preventDefault();
        }
        if (separator && (_event.target.value.includes(".") || _event.target.value.includes(","))) {
            _event.target.preventDefault();
        }
    }

    onInput(_event) {
        let inputValueProcess = _event.target.value.replace(/\s/g, "");
        inputValueProcess = inputValueProcess.replace(".", ",");
        if (!/^-?\d*[\.,]?\d*$/.test(inputValueProcess)) return;
        const inputValueRaw = inputValueProcess.replace(",", ".");
        const rawValueAsNumber = parseFloat(inputValueRaw);
        _event.target.dataset.rawValue = rawValueAsNumber;

        const parts = inputValueProcess.split(",");
        const partsWhole = parts[0];
        const partsDecimal = parts.length > 1 ? "," + parts[1] : "";
        const partsWholeFormat = partsWhole.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        const partsDecimalFormat = partsDecimal;
        this.value = partsWholeFormat + partsDecimalFormat;
        this.numericValue = !!this.value ? parseFloat(this.value.toString().replace(/\s/g, "").replace(",", ".")) : null;
        this.propagateChange(this.numericValue);
    }
}